//MN    YL，JLB，YLD

/// 顶部 --- 统计数据
export const totalConfig = {
  // "MN": "36%",
  // "YL": "45%",
  // "JLB": '14%',
  // "YLD": "5%",
  "MN总品项": "99%",
  "YL总品项": "89%",
  "YLD总品项": "88%",
  "JLB总品项": "66%",

}

/// ----
export const tableDataArr1 = [
  {
    "product": "07-01",
    "MN": 98,
    "YL": 91,
    "JLB": 57,
    "YLD": 91,
  },
  {
    "product": "07-02",
    "MN": 98,
    "YL": 79,
    "JLB": 76,
    "YLD": 78,
  },
  {
    "product": "07-03",
    "MN": 99,
    "YL": 84,
    "JLB": 66,
    "YLD": 79,
  },
  {
    "product": "07-04",
    "MN": 97,
    "YL": 91,
    "JLB": 69,
    "YLD": 89,
  },
  {
    "product": "07-05",
    "MN": 97,
    "YL": 82,
    "JLB": 53,
    "YLD": 80,
  },
  {
    "product": "07-06",
    "MN": 95,
    "YL": 77,
    "JLB": 69,
    "YLD": 88,
  },
  {
    "product": "07-07",
    "MN": 88,
    "YL": 91,
    "JLB": 72,
    "YLD": 89,
  },
  {
    "product": "07-08",
    "MN": 91,
    "YL": 85,
    "JLB": 67,
    "YLD": 87,
  }
]
export const tableDataArr2 = [
  {
    "product": "北京",
    "MN": 80,
    "YL": 87,
    "JLB": 95,
    "YLD": 95,
  },
  {
    "product": "东北",
    "MN": 84,
    "YL": 92,
    "JLB": 85,
    "YLD": 79,
  },
  {
    "product": "华北",
    "MN": 84,
    "YL": 92,
    "JLB": 52,
    "YLD": 91,
  },
  {
    "product": "华东",
    "MN": 79,
    "YL": 80,
    "JLB": 69,
    "YLD": 88,
  },
  {
    "product": "华南",
    "MN": 79,
    "YL": 92,
    "JLB": 32,
    "YLD": 92,
  },
  {
    "product": "华中",
    "MN": 74,
    "YL": 82,
    "JLB": 28,
    "YLD": 87,
  },
  {
    "product": "闽赣",
    "MN": 72,
    "YL": 73,
    "JLB": 57,
    "YLD": 94,
  },
  {
    "product": "山东",
    "MN": 73,
    "YL": 64,
    "JLB": 94,
    "YLD": 92,
  },
  {
    "product": "上海",
    "MN": 73,
    "YL": 84,
    "JLB": 86,
    "YLD": 98,
  },
  {
    "product": "西北",
    "MN": 65,
    "YL": 72,
    "JLB": 77,
    "YLD": 92,
  },
  {
    "product": "西南",
    "MN": 74,
    "YL": 56,
    "JLB": 11,
    "YLD": 73,
  },
  {
    "product": "豫皖",
    "MN": 54,
    "YL": 53,
    "JLB": 86,
    "YLD": 92,
  }
]

export const tableDimensionArr = ["product", "MN", "YL", "JLB", "YLD"]

///
export const modernChartDataArr = [

  {
    type: 'line',
    animationDuration: 2800,
    animationEasing: 'cubicInOut',
    markLine: {
      silent: true,
      label: {
        normal: {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        },
      },
    },
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 12,
        "position": "inside"
      }
    },
  },
  {
    type: 'line',
    animationDuration: 2800,
    animationEasing: 'cubicInOut',
    markLine: {
      silent: true,
      label: {
        normal: {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        },
      },
    },
  },
  {
    type: 'line',
    animationDuration: 2800,
    animationEasing: 'cubicInOut',
    markLine: {
      silent: true,
      label: {
        normal: {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        },
      },
    },
  },
  {
    type: 'line',
    animationDuration: 2800,
    animationEasing: 'cubicInOut',
    markLine: {
      silent: true,
      // lineStyle: {
      //   normal: {
      //     "show": true,
      //     "color": "black",
      //     "fontSize": 10,
      //     "position": "inside"
      //   }
      // },
      // data: [{
      //   yAxis: 34
      // }],
      label: {
        normal: {
          // formatter: '达标线34',           // 这儿设置安全基线
          // position: 'middle',
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        },
      },
    },
  },

]





// WEBPACK FOOTER //
// ./src/components/kpi/config/modernMarketRateConfig.js